export const SUPPORT_FORM_URL = `https://app.smartsheet.com/b/form/3feb65b4134e40cfa0d90306a8cfc91e?${new URLSearchParams(
  {
    'Your ticket concerns:': 'Editing rights request for NZPlanner',
  }
).toString()}`;
